import React from 'react';
import { Form } from 'react-bootstrap';

interface Option {
    value: string;
    label: string;
}

interface SelectProps {
    label: string;
    name: string;
    register: (name: string, options?: any) => any;
    options: Option[];
    className?: string;
    [x: string]: any;
}

const FormSelectCustom: React.FC<SelectProps> = ({ label, name, className, register, options, dirtyField = undefined, ...rest }) => {

    return (
        <div>
            <label htmlFor={name} className={"form-label"+ (dirtyField ? " fieldEdit" : "")}>
                {label}
            </label>
            <select
                id={name}
                className={className ? className : "form-control form-control-sm"}
                {...register(name)}
                {...rest}
            >
                <option value={null}>Select</option>
                {options?.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default FormSelectCustom;
